import { render } from "./DetailList.vue?vue&type=template&id=2a7e039e&scoped=true"
import script from "./DetailList.vue?vue&type=script&lang=js"
export * from "./DetailList.vue?vue&type=script&lang=js"

import "./DetailList.vue?vue&type=style&index=0&id=2a7e039e&scoped=true&lang=css"

import exportComponent from "../../../../irap-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a7e039e"]])

export default __exports__